import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c("span", { staticClass: "text-overline ma-8" }, [
        _vm._v(
          _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.chooseSupplier"))
        ),
      ]),
      _c("vehicle-select", {
        attrs: { companyType: "SUPPLIER" },
        model: {
          value: _vm.companyVehicle,
          callback: function ($$v) {
            _vm.companyVehicle = $$v
          },
          expression: "companyVehicle",
        },
      }),
      _vm.companyVehicle
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-start flex-column font-weight-bold",
            },
            [
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.worksheet.supplierName")
                    ) +
                    ": " +
                    _vm._s(_vm.companyVehicle.companyName) +
                    " "
                ),
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.worksheet.plateNumber")
                    ) +
                    ": " +
                    _vm._s(_vm.companyVehicle.vehicleLicensePlate) +
                    " "
                ),
              ]),
              _vm.companyVehicle.vehicleNotes
                ? _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$vuetify.lang.t("$vuetify.base.notes")) +
                        ": " +
                        _vm._s(_vm.companyVehicle.vehicleNotes) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-8" },
        [
          _c(
            VBtn,
            {
              attrs: {
                disabled: _vm.worksheet.status == "USED",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }